export default [
  {
    path: 'list',
    component: resolve => require(['@/views/list/index'], resolve),
    name: 'list'
  },
  {
    path: 'form1',
    component: resolve => require(['@/views/form1'], resolve),
    name: 'form1'
  },
  {
    path: 'formAndList',
    component: resolve => require(['@/views/formAndList'], resolve),
    name: 'formAndList'
  },
  {
    path: 'childClass',
    component: resolve => require(['@/views/childClass'], resolve),
    name: 'childClass'
  },
  {
    path: 'page',
    component: resolve => require(['@/views/page'], resolve),
    name: 'page'
  }
]


// WEBPACK FOOTER //
// ./src/router/newsClass.js